<template>
  <div id='codeAdd'>
    <!-- 个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="examcode" :rules="rules" ref="examcode">
      <fieldset style="border-width: 2px; border-color: #990000; width:98%; height:220">
        <el-row>
          <el-col :span="3" class="c">
            代码类别名称 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="name" id="name">
              <el-input v-model="examcode.name" :maxlength="25" placeholder="请输入内容" class="DataWidth" :disabled="view"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" class="c">
            代码类别 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="type" id="type">
              <el-input v-model="examcode.type" :maxlength="25" placeholder="请输入内容" class="DataWidth" :disabled="view"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="c">
            代码名称 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="value" id="value">
              <el-input v-model="examcode.value" :maxlength="25" placeholder="请输入内容" class="DataWidth" :disabled="view"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            代码值 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="code" id="code">
              <el-input v-model="examcode.code" :maxlength="25" placeholder="请输入内容" class="DataWidth" :disabled="view"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            是否可用 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="flag" id="flag">
              <el-select v-model="examcode.flag" placeholder="请选择" class="DataWidth" :disabled="view">
                <el-option v-for="item in options_flag" :key="item.code" :label="item.value" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            备注
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="remark" id="remark">
              <el-input type="textarea" :rows="2" style="width:400px" v-model="examcode.remark" placeholder="请输入内容"
                        class="DataWidth" :disabled="view">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'codeAdd',
    created: function () {
      this.options_flag = this.CommonUtil.getCodeList("status");
    },
    mounted: function() {
      this.examcode=this.codeRow;
    },
    watch: {
      "codeRow": function () {
        this.examcode = this.codeRow;
      },
    },
    props: ["codeRow"],
    data() {
      return {
        msg: 'Welcome to Your codeAdd',
        view: true,
        examcode: {
          type: '',
          name: '',
          code: '',
          value: '',
          flag: '',
          remark: ''
        },
        options_flag: [],
        // 测试验证
        rules: {
          name: [{
            required: true,
            message: '请填写名称',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {

    }
  }
</script>
<style scoped>
  div {
    margin-top: 0px;
  }

  .c {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/code/codeView.vue